export const BasicStatuses = {
  NOT_SAVED: 'NOT_SAVED',
  DRAFT: 'DRAFT',
  APPROVED: 'APPROVED',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
} as const;

export const BroadcastStatuses = {
  ...BasicStatuses,
  PUBLISHED: 'PUBLISHED',
} as const;

export const BroadcastDeliveryStatuses = {
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  DELIVERED: 'DELIVERED',
} as const;

export const AllStatuses = {
  ...BroadcastDeliveryStatuses,
  ...BroadcastStatuses,
} as const;

export type AllStatusesTypes = keyof typeof AllStatuses;

export type BasicStatusesTypes = keyof typeof BasicStatuses;

export enum StatusLabels {
  NOT_SAVED = 'Not saved',
  DRAFT = 'Draft',
  APPROVED = 'Approved',
  PUBLISHED = 'Published',
  PENDING_APPROVAL = 'Pending approval',
  PENDING = 'Pending',
  DELIVERED = 'Delivered',
  FAILED = 'Failed',
}
